import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO helper for inner pages.
 * Sets title, description, canonical URL and BreadcrumbList structured data.
 */
export default function Seo({ title, description, path = '/', breadcrumb = [] }) {
  const fullUrl = `https://www.mibax-messtechnik.com${path}`;
  const fullTitle = `${title} – MIBAX Messtechnik`;

  const breadcrumbLd = breadcrumb.length
    ? {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumb.map((b, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: b.name,
          item: `https://www.mibax-messtechnik.com${b.path}`,
        })),
      }
    : null;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="de" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="de_DE" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {breadcrumbLd && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbLd)}
        </script>
      )}
    </Helmet>
  );
}
